import { AddTourEventParams } from '@/domain/project-tour-ontour/actions/add-tour-event.action';
import {
  TourEvent,
  TourEventBasic,
  TourEventType,
  TourEventTypeValues,
} from '@/domain/project-tour-ontour/entities/project-tour-ontour-event.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { PositionDto } from '../position-geocode/position.dto.schema';
import { PositionMapper } from '../position-geocode/position.mapper';
import {
  ImportTourEventDto,
  TourEventDto,
} from './project-tour-event.dto.schema';

type AddTourEventDto = {
  sequenceId: number;
  name: string;
  date: string;
  capacity: number;
  position: PositionDto | undefined;
  type: string;
};

type EditTourEventDto = {
  name: string;
  date: string;
  capacity: number;
  position: PositionDto | undefined;
  type: string;
};

export class TourEventMapper {
  static dtoToEntity(dto: TourEventDto): TourEvent {
    return {
      id: dto.id,
      sequenceId: Number.parseInt(dto.sequenceId.toString()),
      name: dto.name,
      date: dto.date,
      capacity: dto.capacity,
      position: dto.position
        ? PositionMapper.dtoToEntity(dto.position)
        : undefined,
      type: validateValueInType<TourEventType>(dto.type, TourEventTypeValues),
    };
  }

  static prepareAddEventDto(
    sequenceId: number,
    tourEvent: AddTourEventParams['tourEvent'],
  ): AddTourEventDto {
    return {
      sequenceId: sequenceId,
      name: tourEvent.name,
      date: tourEvent.date,
      capacity: tourEvent.capacity,
      position: tourEvent.position
        ? PositionMapper.entityToDto(tourEvent.position)
        : undefined,
      type: tourEvent.type,
    };
  }

  static prepareEditEventDto(tourEvent: TourEvent): EditTourEventDto {
    return {
      name: tourEvent.name,
      date: tourEvent.date,
      capacity: tourEvent.capacity,
      position: tourEvent.position
        ? PositionMapper.entityToDto(tourEvent.position)
        : undefined,
      type: tourEvent.type,
    };
  }
}

export class ImportTourEventMapper {
  static dtoToEntity(dto: ImportTourEventDto): TourEventBasic {
    return {
      name: dto.name,
      date: dto.date,
      position: dto.position
        ? PositionMapper.dtoToEntity(dto.position)
        : undefined,
      capacity: dto.capacity,
    };
  }
}
